import { apiCall, http } from '../http'

export interface WebSocketTokenResponse {
    token: string
    wsUrl: string
    connectorId: string
}

/**
 * Получить токен для WebSocket подключения
 */
export async function getWebSocketToken(params: { projectId: string }) {
    const url = `messenger/ws-token`
    const { data, error } = await apiCall<WebSocketTokenResponse>(() =>
        http.get(url, {
            searchParams: {
                projectId: params.projectId,
            },
        })
    )
    return { data, error }
}